/**
 * Created by USER on 18/6/13.
 */
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {Tabs} from 'antd';
import {changeBarState} from '../redux/actions/headerbar_action';
import ImgList from '../images/img';

const {TabPane} = Tabs;

class AboutLUBANSO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'left',
      isRender: false,
      state: 'aboutLUBANSO'
    };
  }

  componentWillMount() {
    this.props.dispatch(changeBarState('about_lubanso'));
  }

  componentDidMount() {
    this.setState({
      state: this.props.location.state // 改变state 组件生成时 设置tab default
    });
    const {offsetWidth} = document.body;
    if (offsetWidth < 768) {
      this.setState({
        mode: 'top' // 根据浏览器的大小设置tab的方向
      });
    }

    window.onresize = () => { // 浏览器窗口大小改变时，去做判断，tab的方向
      const { offsetWidth } = document.body;
      if (offsetWidth < 768) {
        this.setState({
          mode: 'top'
        });
      } else {
        this.setState({
          mode: 'left'
        });
      }
    };
  }

  componentWillReceiveProps(nextProps) { // 根据下一次状态的改变 来作出相应的动作
    if (nextProps.location.state !== this.props.location.state) {
      this.setState({
        isRender: false //是否渲染页面
      });
      setTimeout(() => {
        this.setState({
          isRender: true
        });
      }, 500);
    } else {
      this.setState({
        isRender: true
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => {});
  }

  render() {
    const { t } = this.props;
    const {mode, isRender} = this.state;
    const {state} = this.props.location;
    return (
      isRender ?
        <div className="about_lubanso">
          <Tabs
            defaultActiveKey={!state ? 'aboutLUBANSO' : state}
            tabPosition={mode}
            style={{ minHeight: 400 }}
          >
            <TabPane tab={t('about_lubanso')} key="aboutLUBANSO">
              <div className="about_LUBANSO_title">{t('about_lubanso')}</div>
              <div className="agreement_content">
                <div className="agreement_notice">
                  {t('about_lubanso_title')}
                </div>
                <div className="agreement_secondary_title">
                  {t('about_lubanso_details_title1')}
                </div>
                <p>
                  {t('about_lubanso_details1_1')}
                </p>
                <div className="agreement_secondary_title">
                  {t('about_lubanso_details_title2')}
                </div>
                <p>
                  {t('about_lubanso_details2_1')}
                </p>
                <div className="agreement_secondary_title">
                  {t('about_lubanso_details_title3')}
                </div>
                <p>{t('about_lubanso_details3_1')}</p>
                <p>{t('about_lubanso_details3_2')}</p>
                <div className="agreement_secondary_title">
                  {t('about_lubanso_details_title4')}
                </div>
                <p>{t('about_lubanso_details4_1')}</p>
                <p>{t('about_lubanso_details4_2')}</p>
                <p>{t('about_lubanso_details4_3')}</p>
                <p>{t('about_lubanso_details4_4')}</p>
                <p>{t('about_lubanso_details4_5')}</p>
                <p>{t('about_lubanso_details4_6')}</p>
                <p>{t('about_lubanso_details4_7')}</p>
                <p>{t('about_lubanso_details4_8')}</p>
                <div className="agreement_secondary_title">
                  {t('about_lubanso_details_title5')}
                </div>
                <p>{t('about_lubanso_details5_1')}</p>
                <p>{t('about_lubanso_details5_2')}</p>
                <p>{t('about_lubanso_details5_3')}</p>
                <div className="agreement_secondary_title">
                  {t('about_lubanso_details_title6')}
                </div>
                <p>
                  {t('about_lubanso_details6_1')}
                </p>
              </div>
            </TabPane>
            <TabPane tab={t('use_agreement')} key="agreement">
              <div className="about_LUBANSO_title">{t('use_agreement')}</div>
              <div className="agreement_content">
                <div className="agreement_notice">
                  {t('use_agreement_title')}
                </div>
                <div className="agreement_secondary_title">
                  {t('use_agreement_details_title1')}
                </div>
                <p>
                  {t('use_agreement_details1_1')}
                </p>
                <div className="agreement_secondary_title">
                  {t('use_agreement_details_title2')}
                </div>
                <p>
                  {t('use_agreement_details2_1')}
                </p>
                <p>
                  {t('use_agreement_details2_2')}
                </p>
                <p>
                  {t('use_agreement_details2_3')}
                </p>
                <div className="agreement_secondary_title">
                  {t('use_agreement_details_title3')}
                </div>
                <p>
                  {t('use_agreement_details3_1')}
                </p>
                <p>
                  {t('use_agreement_details3_2')}
                </p>
                <div className="agreement_secondary_title">
                  {t('use_agreement_details_title4')}
                </div>
                <p>
                  {t('use_agreement_details4_1')}
                </p>
                <p>
                  {t('use_agreement_details4_2')}
                </p>
                <p>
                  {t('use_agreement_details4_3')}
                </p>
                <div className="agreement_secondary_title">
                  {t('use_agreement_details_title5')}
                </div>
                <p>
                  {t('use_agreement_details5_1')}
                </p>
                <p>
                  {t('use_agreement_details5_2')}
                </p>
              </div>
            </TabPane>
            <TabPane tab={t('after_sale')} key="afterSales">
              <div className="about_LUBANSO_title">{t('after_sale')}</div>
              <div>
                <div className="agreement_secondary_title">
                  {t('after_sale_details_title1')}
                </div>
                <p>
                  {t('after_sale_details1_1')}
                </p>
                <p>{t('after_sale_details1_2')}</p>
                <p>{t('after_sale_details1_3')}</p>
                <p>{t('after_sale_details1_4')}</p>
                <div className="agreement_secondary_title">
                  {t('after_sale_details_title2')}
                </div>
                <p>
                  {t('after_sale_details2_1')}
                </p>
                <p>
                  {t('after_sale_details2_2')}
                </p>
                <p>
                  {t('after_sale_details2_3')}
                </p>
                <p>
                  {t('after_sale_details2_4')}
                </p>
                <div className="maintenance_pay_qrcode">
                  <div>
                    <div>
                      <div className="maintenance_pay_title">{t('alipay')}</div>
                      <img src={ImgList.img.alipayQrcode} alt="LUBANSO" />
                    </div>
                    <div>
                      <div className="maintenance_pay_title">{t('wechat')}</div>
                      <img src={ImgList.img.wechatQrcode} alt="LUBANSO" />
                    </div>
                  </div>
                </div>
                <div className="agreement_secondary_title">
                  {t('after_sale_details_title3')}
                </div>
                <div className="agreement_secondary_title">
                  {t('after_sale_details3_title1')}
                </div>
                <p>{t('after_sale_details3_details1_1')}</p>
                <p>{t('after_sale_details3_details1_2')}</p>
                <p>{t('after_sale_details3_details1_3')}</p>
                <p>{t('after_sale_details3_details1_4')}</p>
                <p>{t('after_sale_details3_details1_5')}</p>
                <p>{t('after_sale_details3_details1_6')}</p>
                <div className="agreement_secondary_title">
                  {t('after_sale_details3_details1_2')}
                </div>
                <p>
                  {t('after_sale_details3_details2_1')}
                </p>
                <div className="agreement_secondary_title">
                  {t('after_sale_details3_details1_3')}
                </div>
                <p>
                  {t('after_sale_details3_details3_1')}
                </p>
                <div className="agreement_secondary_title">
                  {t('after_sale_details3_details1_4')}
                </div>
                <p>{t('after_sale_details3_details4_1')}</p>
                <p>{t('after_sale_details3_details4_2')}</p>
                <p>{t('after_sale_details3_details4_3')}</p>
                <p>{t('after_sale_details3_details4_4')}</p>
                <p>{t('after_sale_details3_details4_5')}</p>
                <p>{t('after_sale_details3_details4_6')}</p>
                <p>{t('after_sale_details3_details4_7')}</p>
                <div className="agreement_secondary_title">
                  {t('after_sale_details3_details1_5')}
                </div>
                <p>{t('after_sale_details3_details5_1')}</p>
                <p>{t('after_sale_details3_details5_2')}</p>
                <p>{t('after_sale_details3_details5_3')}</p>
                <p>{t('after_sale_details3_details5_4')}</p>
                <p>{t('after_sale_details3_details5_5')}</p>
              </div>
            </TabPane>
          </Tabs>
        </div> : null
    );
  }
}

// {/*<TabPane tab="团队" key="team">*/}
//   {/*<div className="about_LUBANSO_title">团队</div>*/}
// {/*</TabPane>*/}

function select(state) {
  return {
    appBarReducer: state.appBarReducer
  };
}

const AboutLUBANSOConnected = connect(select)(AboutLUBANSO);

export default translate('translations')(AboutLUBANSOConnected);
